import { createUseStyles } from "react-jss";
import { breakpoints } from "../../constants/breakpoints";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  container: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "48px 0px",
    maxWidth: "352px",
    "& h1": {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      color: colors.lightBlack,
      marginBottom: "0px",
      marginTop: "16px"
    },
    "& p": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: "0px",
      marginTop: "4px"
    },
    "& path": {
      stroke: theme.icon.stroke
    }
  },
  clearBtn: {
    marginTop: "24px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "10px 10px",
    },
    "& span": {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "22px",
    }
  },
  clearBtnLoadingState: {
    backgroundColor: `${colors.white} !important`,
    border: theme.buttons.default.border,
    "& span": {
      borderColor: `${colors.grey} ${colors.grey} transparent !important`
    }
  }
}));

export default styles;